import axios from "axios";
import { formatDate } from "utils/date";
import { buildQuery } from "utils/queryUtils";

export const findRegisters = (headers, params) => {
    let query = buildQuery(params, ["idNumber", "phoneNumber", "fullName", "addressLine"]);
    let searchText = "";
    if (params.filters.idNumber?.value) {
        searchText += `&idNumber=${params.filters.idNumber?.value?.trim()}`;
    }
    if (params.filters.phoneNumber.value) {
        searchText += `&phoneNumber=${params.filters.phoneNumber.value?.trim()}`;
    }
    if (params.filters.toDate.value) {
        searchText += `&toDate=${formatDate(params.filters.toDate.value)}`;
    }
    if (params.filters.fromDate.value) {
        searchText += `&fromDate=${formatDate(params.filters.fromDate.value)}`;
    }
    return axios.get(`${process.env.REACT_APP_IDP_API_URL}/account-registers/list${query}${searchText}`, {
        headers,
    });
};
